import type { AlertManager } from '../managers/AlertManager';
import { thankYouEventBus } from '../managers/ThankYouManager/ThankYouEventBus';
import type { TranslationGetter } from '../types';

export class ThankYouController {
  private verificationEmailSentBinding: ReturnType<typeof thankYouEventBus.bindTo> | null = null;

  private verificationEmailFailedBinding: ReturnType<typeof thankYouEventBus.bindTo> | null = null;

  constructor(private alertManager: AlertManager) {}

  public initializeListeners(t: TranslationGetter) {
    // Clean up any existing listeners first
    this.cleanup();

    this.verificationEmailSentBinding = thankYouEventBus.bindTo(
      'verificationEmailSent',
      async (emailAddress: string) => {
        const alertApi = await this.alertManager.getApiWhenReady();

        // Remove existing alerts and show new one to create flicker effect
        alertApi.removeAlert('verification-email-sent');
        alertApi.removeAlert('verification-email-error');

        // Use setTimeout to ensure the DOM updates before adding new alert
        setTimeout(() => {
          alertApi.addAlert({
            id: 'verification-email-sent',
            variant: 'success',
            message: t('application-layer.thank-you-page.verification-email-sent', {
              email: emailAddress,
            }),
          });
        }, 100);
      }
    );

    this.verificationEmailFailedBinding = thankYouEventBus.bindTo('verificationEmailFailed', async () => {
      const alertApi = await this.alertManager.getApiWhenReady();

      // Remove existing alerts and show new one
      alertApi.removeAlert('verification-email-sent');
      alertApi.removeAlert('verification-email-error');

      setTimeout(() => {
        alertApi.addAlert({
          id: 'verification-email-error',
          variant: 'warning',
          message: t('application-layer.thank-you-page.verification-email-error'),
        });
      }, 100);
    });

    this.verificationEmailSentBinding.on();
    this.verificationEmailFailedBinding.on();
  }

  public cleanup() {
    if (this.verificationEmailSentBinding) {
      this.verificationEmailSentBinding.off();
      this.verificationEmailSentBinding = null;
    }

    if (this.verificationEmailFailedBinding) {
      this.verificationEmailFailedBinding.off();
      this.verificationEmailFailedBinding = null;
    }
  }
}
